import ApiService from '@/services/core/api.service'

const AdminProductService = {
  async get (query) {
    return ApiService.get(`admin/products?${query}`)
  }
}

export default AdminProductService
